/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Hexvalue1Inputs */

const en_entity_hexvalue1 = /** @type {(inputs: Entity_Hexvalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hex Value`)
};

const de_entity_hexvalue1 = /** @type {(inputs: Entity_Hexvalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hex-Wert`)
};

/**
* | output |
* | --- |
* | "Hex Value" |
*
* @param {Entity_Hexvalue1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_hexvalue1 = /** @type {((inputs?: Entity_Hexvalue1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Hexvalue1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_hexvalue1(inputs)
	return de_entity_hexvalue1(inputs)
});
export { entity_hexvalue1 as "entity_hexValue" }